"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation removeFeatureService($deleteFeature: DeleteLikedFeatureInput!) {
        deleteLikedFeature(input: $deleteFeature) {
            feature {
                type
                url
                name
                featureId
            }
        }
    }
`;exports.removeFeature=e;
//# sourceMappingURL=queries.js.map
